import { render, staticRenderFns } from "./EmployeeNocDocuments.vue?vue&type=template&id=74c8ad39&scoped=true"
import script from "./EmployeeNocDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeNocDocuments.vue?vue&type=script&lang=js"
import style0 from "./EmployeeNocDocuments.vue?vue&type=style&index=0&id=74c8ad39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8ad39",
  null
  
)

export default component.exports